/**
 * The templateMapper folder is copied as-is from composition-api.
 * WARNING: Any updates made to templateMapper in composition-api,
 * should be copied here as well for the time being
 * Refer: https://gitlab.nordstrom.com/cxa/digital-assembly/composition-api
 */

const {
  HP_TOP_BANNER,
  HP_HERO,
  IN_YOUR_BAG,
  LOOKS_REC_TRAY,
  RECOMMENDATION_SHELF,
  HP_RANKED_RESULTS,
  PROMO_TILE,
  HP_SERVICES,
  MORE_TO_EXPLORE,
  PHP_TILE_PREVIEW,
  REMAINING_COMPONENTS
} = require('./constants');

const placements = require('./placements');

const PHP_TEMPLATE = [
  HP_TOP_BANNER,
  HP_HERO,
  IN_YOUR_BAG,
  LOOKS_REC_TRAY,
  RECOMMENDATION_SHELF,
  HP_RANKED_RESULTS,
  HP_SERVICES,
  RECOMMENDATION_SHELF,
  HP_RANKED_RESULTS,
  PROMO_TILE,
  RECOMMENDATION_SHELF,
  HP_RANKED_RESULTS,
  HP_SERVICES,
  RECOMMENDATION_SHELF,
  MORE_TO_EXPLORE,
  RECOMMENDATION_SHELF
];

const CANVAS_PHP_PREVIEW_TEMPLATE = [PHP_TILE_PREVIEW, ...PHP_TEMPLATE, REMAINING_COMPONENTS];

/**
 * templateMapper - This function takes a list of Components, reorders and modifies them as
 * specified by the template. If a template is not provided, it will organize the components
 * into the MOW Personalized Homepage experience.
 *
 * @param {Array} components - Components' data to be used as a pool to draw from for the template
 * @param {Array} template - An array of placement strings that correspond to placement functions
 * @returns {Array} - The modified list of components, reordered and modified by the template
 */
module.exports = function templateMapper(components, template = CANVAS_PHP_PREVIEW_TEMPLATE) {
  const processedComponents = template.reduce(
    (acc, cur) => {
      // Skip if there's no matching placement defined
      return (placements[cur] && placements[cur](acc)) || acc;
    },
    {
      pool: components,
      result: [],
      recPlacementIndex: 0
    }
  );

  return processedComponents.result;
};
